/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, Type, inject } from '@angular/core';
import { ChosenWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { AvailableWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { IWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ConfigureWidgetParms } from '@src/app/shared/dashboard/dashboard.component';
import { WidgetContentHolderComponent } from '@src/app/shared/dashboard/widget-content-holder/widget-content-holder';
import { MatTooltip } from "@angular/material/tooltip";
import { NavRoute } from '@src/app/shared/NavRoute';
import { DashboardChart } from '@src/app/shared/dashboard/dashboard-widget/dashboard-chart';

@Component({
    selector: 'app-dashboard-widget',
    templateUrl: './dashboard-widget.component.html',
    styleUrls: ['./dashboard-widget.component.scss'],
    imports: [MatButtonModule, MatMenuModule, MatIconModule, WidgetContentHolderComponent, MatTooltip]
})
export class DashboardChartComponent implements OnChanges {
    private http = inject(HttpClient);
    private host = inject(ElementRef);


    dashboardChart: IWidget; // DashboardChart;
    availableWidget: AvailableWidget;
    componentType: Type<IWidget>;
    @Input() availCharts: AvailableWidget[];
    @Input() chosenWidget: ChosenWidget;
    widgetType: 'chart'|'component';

    public get title() {
        if (this.componentType['title']) {
            return this.componentType['title']
        }
        return 'Unknown widget';
    }

    public get subTitle() {
        if (this.componentType['subTitle']) {
            return this.componentType['subTitle']
        }
        return '';
    }

    public get navRoute() : NavRoute {
        if (this.componentType['getNavRoute']) {
            const route = this.componentType['getNavRoute']();
            return route;
        }
        return null;
    }

    @Output() updateSettings = new EventEmitter<ConfigureWidgetParms>();

    chartRandomId: string = 'chartId-' + Math.floor(Math.random() * 1000000000);

    toggleOn = true;

    ngOnChanges(simpleChanges: SimpleChanges) {
        if (this.availCharts) {
            if (simpleChanges.chosenWidget?.currentValue !== simpleChanges.chosenWidget.previousValue) {
                this.showWidget()
            }
        }
    }

    doUpdateSettings($event) {
        this.updateSettings.emit({event: $event, chosenWidget: this.chosenWidget, changeWidget: this.changeWidget.bind(this)})
    }

    changeWidget(to: AvailableWidget) {
        this.chosenWidget.code = to.code;
        this.showWidget();
    }

    isDashboardChartClass(widgetClass: Type<IWidget>): boolean{
        const proto = widgetClass?.prototype;
        return !!proto && proto instanceof DashboardChart;
    }

    showWidget() {
        this.availableWidget = this.availCharts.find(ac => ac.code === this.chosenWidget.code);

        if (!this.isDashboardChartClass(this.availableWidget.widgetClass)) {
            this.widgetType = 'component';
            const el = document.getElementById(this.chartRandomId);
            if (el) el.innerHTML = ''; // Clear any existing chart may have been there before!            
            this.componentType = this.availableWidget.widgetClass;
        } else {
            this.componentType = null;
            this.widgetType = 'chart';
            const WidgetClass = this.availableWidget.widgetClass;
            this.availableWidget.chart = new WidgetClass(this.chosenWidget) as DashboardChart;
            this.availableWidget.chart.host = this.host;    
            this.availableWidget.chart.getData(this.chartRandomId);
        }
    }
}
